import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import { WorkspaceProvider } from "@/contexts/WorkspaceContext";
import { Toaster } from "@/components/ui/sonner";

import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Scraper from "@/pages/Scraper";
import Pipeline from "@/pages/Pipeline";
import Leads from "@/pages/Leads";
import LeadDetail from "@/pages/LeadDetail";
import Campaign from "@/pages/Campaign";
import Settings from "@/pages/Settings";
import ROI from "@/pages/ROI";
import Analytics from "@/pages/Analytics";
import ABHistory from "@/pages/ABHistory";
import Team from "@/pages/Team";
import Import from "@/pages/Import";
import McpAccess from "@/pages/McpAccess";
import PublicBooking from "@/pages/PublicBooking";
import Help from "@/pages/Help";

import ProtectedRoute from "@/components/ProtectedRoute";
import AppLayout from "@/components/layout/AppLayout";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <WorkspaceProvider>
            <Toaster position="top-right" />
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/book/:token" element={<PublicBooking />} />
              <Route path="/m/:slug" element={<PublicBooking />} />
              <Route element={<ProtectedRoute><AppLayout /></ProtectedRoute>}>
                <Route path="/" element={<Dashboard />} />
                <Route path="/scraper" element={<Scraper />} />
                <Route path="/import" element={<Import />} />
                <Route path="/mcp-access" element={<McpAccess />} />
                <Route path="/pipeline" element={<Pipeline />} />
                <Route path="/leads" element={<Leads />} />
                <Route path="/leads/:id" element={<LeadDetail />} />
                <Route path="/campaign" element={<Campaign />} />
                <Route path="/roi" element={<ROI />} />
                <Route path="/analytics" element={<Analytics />} />
                <Route path="/ab-history" element={<ABHistory />} />
                <Route path="/settings" element={<Settings />} />
                <Route path="/team" element={<Team />} />
                <Route path="/help" element={<Help />} />
              </Route>
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </WorkspaceProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
